import { observer } from 'mobx-react-lite';
import { Route, Routes } from 'react-router-dom';
import { FlexFill, Footer, Tab, Tabs } from '../../../../components';
import { useIsAdmin } from '../../../../store';
import ArchiveSellableButton from '../../../products/edit/components/sellable/ArchiveSellableButton';
import SaveSellableButton from '../../../products/edit/components/sellable/SaveSellableButton';
import Products from '../../../products/store/Products';
import Bundle from '../../store/Bundle';
import BundleGeneralPanel from './BundleGeneralPanel';
import BundleKeysPanel from './BundleKeysPanel';

export default observer(function BundleForm({
  bundle,
  products,
}: {
  bundle: Bundle;
  products: Products;
}) {
  // Bundle keys aren't public yet
  const isAdmin = useIsAdmin({ mode: 'any' });

  if (!isAdmin) {
    return (
      <>
        <BundleGeneralPanel bundle={bundle} products={products} />
        <BundleFooter bundle={bundle} />
      </>
    );
  }

  return (
    <>
      {!bundle.isNew && (
        <Tabs>
          <Tab label="General" value="" />
          <Tab label="Pulse Keys" value="pulse-keys" />
        </Tabs>
      )}

      <Routes>
        <Route
          element={<BundleGeneralPanel bundle={bundle} products={products} />}
          index
        />
        <Route
          element={<BundleKeysPanel bundle={bundle} />}
          path="pulse-keys"
        />
      </Routes>

      <BundleFooter bundle={bundle} />
    </>
  );
});

function BundleFooter({ bundle }: { bundle: Bundle }) {
  return (
    <Footer sx={{ mt: 4 }}>
      <SaveSellableButton sellable={bundle} sellableName="Bundle" />
      <ArchiveSellableButton sellable={bundle} sellableName="Bundle" />
      <FlexFill />
    </Footer>
  );
}
